import { getDelivery, updateDelivery } from '../services/napi';
import { FETCH_DELIVERIES, SET_DELIVERY_DRAFT } from '../constant/actionType';

export function getAllDelivery() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    try {
      const response = await getDelivery(projectId);
      dispatch({ data: response.data.deliveries, type: FETCH_DELIVERIES });
    } catch (error) {
      console.error(error);
    }
  };
}

export function saveDelivery({ id, body }) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    try {
      await updateDelivery(projectId, id, body);
    } catch (error) {
      console.error(error);
    }
  };
}

export function setDeliveryDraft(data) {
  return (dispatch) => {
    dispatch({
      data,
      type: SET_DELIVERY_DRAFT
    });
  };
}
